import React, { useEffect, useState } from 'react';
import { FilterProps } from '../../Handbooks.types';
import { Styled } from '../../Handbooks.styles';
import { useRouteMatch } from 'react-router';
import { IconButton, Button, PrimaryButton } from 'office-ui-fabric-react';
import { Pager } from '../Pager';
import {
  makeFilter,
  FilterComparision,
  IAcceptFilterData,
  makeAllFilter,
  convertMinutesToTime,
} from 'views/components/SpreadSheet/utils';
import Th from './Th';

export const Filters: React.FC<FilterProps> = (props: FilterProps) => {
  const [filters, setFilters] = useState([]);
  const [isFullVisible, setIsFullVisible] = useState<boolean>(false);
  const [showingFilterField, setShowingFilterField] = useState<
    string | undefined
  >(undefined);
  const [allFilters, setAllFilters] = useState<{ [key: string]: any }>({});
  const [sort, setSort] = useState<{ field: string; direction: string }>(
    props.sort
  );

  const config = props.config;
  const connections = props.connections;

  return (
    <>
      <Styled.FilterHidden>
        <Styled.FilterBlock>
          <IconButton
            onClick={() => setIsFullVisible(!isFullVisible)}
            iconProps={{
              iconName: filters && filters.length ? 'FilterSolid' : 'Filter',
            }}
          />
        </Styled.FilterBlock>
        {(!isFullVisible && (
          <Pager
            currentPage={props.currentPage}
            pageCount={props.pageCount}
            onPageChanged={props.onPageChanged}
          />
        )) || (
          <Button
            onClick={() => setAllFilters({})}
            iconProps={{
              iconName: 'ClearFilter',
            }}
            text={'Сбросить фильтры'}
          ></Button>
        )}
      </Styled.FilterHidden>
      {isFullVisible && (
        <Styled.FilterFull>
          <Styled.FilterFields>
            {config.fields.map(
              (el: any) =>
                !el.disableFilter && (
                  <Th
                    config={config}
                    key={`th-${el.name}`}
                    field={{
                      title: el.title,
                      name: el.name,
                      type: el.type,
                      width: el.width,
                      connection: el.connection,
                      disableFilter: el.disableFilter,
                      values: el.values,
                    }}
                    sort={sort}
                    allFilters={allFilters}
                    onSortChange={(field: string, direction: string) =>
                      setSort({ field, direction })
                    }
                    onFilterShow={(fieldName?: string) =>
                      setShowingFilterField(fieldName)
                    }
                    onFilterAccept={(filter: IAcceptFilterData) => {
                      const filters = { ...allFilters };
                      filters[filter.field.name] = filter;
                      setAllFilters(filters);
                    }}
                    showFilter={showingFilterField === el.name}
                    connection={
                      el.connection && connections
                        ? {
                            config: config.connections[el.connection],
                            list: connections[el.connection] || [],
                          }
                        : undefined
                    }
                  />
                )
            )}
          </Styled.FilterFields>
          <Styled.FilterButtons>
            <PrimaryButton
              onClick={() => {
                props.onSetFilter(makeAllFilter(allFilters), sort);
                setIsFullVisible(false);
              }}
            >
              Закрыть
            </PrimaryButton>
          </Styled.FilterButtons>
        </Styled.FilterFull>
      )}
    </>
  );
};
